import React from 'react';
import {Body} from '@lightricks/react-design-system';
import {SlotFilter} from '../../types';
import styles from './FilterChips.module.scss';

const ORDER: {key: SlotFilter; label: string}[] = [
  {key: 'needs_action', label: 'Needs action'},
  {key: 'in_review', label: 'In review'},
  {key: 'approved', label: 'Done'},
  {key: 'all', label: 'All'},
  {key: 'archived', label: 'Archived'},
];

interface Props {
  active: SlotFilter;
  counts: Record<SlotFilter, number>;
  onChange: (f: SlotFilter) => void;
}

export default function FilterChips({active, counts, onChange}: Props) {
  return (
    <div className={styles.track}>
      <div
        className={styles.chips}
        role="group"
        aria-label="Filter deliverables"
      >
        {ORDER.map(({key, label}) => (
          <button
            key={key}
            type="button"
            data-testid={`filter-chip-${key}`}
            data-active={active === key}
            aria-pressed={active === key}
            className={styles.chip}
            onClick={() => onChange(key)}
          >
            <Body size="sm">{`${label} ${counts[key]}`}</Body>
          </button>
        ))}
      </div>
    </div>
  );
}
